var CurrentUser = require("lib/account/CurrentUser");
var ProgressBar = require("components/utility/ProgressBar");
var StudentReportModal = require("components/users/students/StudentReportModal");
var DocumentClient = require("lib/web/DocumentClient");

require("users/students/progress_display.scss");

class ProgressDisplay extends React.Component {
	constructor(props) {
		super();
		autobind(this);
	}
	showReportModal(e) {
		$wr.nope(e)
		if (CurrentUser.isStudent()) {
			this.refs.modal.show();			
		} else {
			this.openReport();
		}
	}

	openReport() {
		var reportURL = "/student_reports/student_report?student_id=" +
			this.props.studentID + "&date=" + this.props.reportDate;

		DocumentClient.open(reportURL);
	}

	render() {
		if (this.props.reportDate != null) {
			var reportLink = (
				<span>
					<a href="#" className="fullReportLink"
						onClick={ this.showReportModal }>
						View HOOTS Report!
					</a>
					<StudentReportModal ref="modal" openReport={ this.openReport } />
				</span>
			);
		}

		
		var actionLink = (
			<a href="#" className="buttonPrimary" onClick={ this.props.onActionClick }>
				{ this.props.actionLabel }
			</a>
		);	

		var currentValue = this.props.current;

		if (currentValue) {
			var displayValue = $wr.numberWithCommas(this.props.current);
		} else {
			var displayValue = 0;
		}

		return (
			<div className="progressDisplay">
				<p className="timeSpanTitle">{ this.props.title }</p>
				<p className="pointsTotal">
					{ displayValue }
					/
					{ $wr.numberWithCommas(this.props.total || 0) }
					{ " " }
					{ this.props.unit }
				</p>
				<ProgressBar current={ this.props.current } total={ this.props.total } />
				{ reportLink }
				{ actionLink }
			</div>
		)
	}
}

ProgressDisplay.propTypes = PageStrictPropTypes({
	title: PropTypes.string.isRequired,
	current: PropTypes.number.isRequired,
	total: PropTypes.number.isRequired,
	unit: PropTypes.string.isRequired,
	reportDate: PropTypes.string,
	studentID: PropTypes.number,
	actionLabel: PropTypes.string,
	onActionClick: PropTypes.func
});

module.exports = ProgressDisplay;


// WEBPACK FOOTER //
// ./modules/components/users/students/ProgressDisplay.js